import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const sensorValuesApi = createApi({
  reducerPath: 'sensorValuesApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    getSensorValuesPreview: builder.mutation({
      query: (data) => {
        return {
          url: urls.sensorValuesPreview,
          method: 'POST',
          data: {
            sensor_attribute_ids: data.sensor_attribute_ids,
            from: data.dates[0].format(),
            to: data.dates[1].format(),
          },
        };
      },
    }),
    getSensorValuesStatistics: builder.mutation({
      query: (data) => {
        return {
          url: urls.sensorValuesStatistics,
          method: 'POST',
          data: {
            meteo_sensor_attribute_id: data.meteo_sensor_attribute_id,
            from: data.dates[0].format(),
            to: data.dates[1].format(),
            type_of_statistics: data.type_of_statistics,
          },
        };
      },
    }),
  }),
});

export const {
  useGetSensorValuesPreviewMutation,
  useGetSensorValuesStatisticsMutation,
} = sensorValuesApi;
